import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { doCreatePartner, doGetPartner, doGetPartners, doRemovePartner, doUpdatePartner } from './thunk';

const isActionWithPending = (action) => {
  return action.type && action.type.startsWith('Partners/') && action.type.endsWith('/pending');
};

const isActionWithFulfilled = (action) => {
  return action.type && action.type.startsWith('Partners/') && action.type.endsWith('/fulfilled');
};

const isActionWithFailed = (action) => {
  return action.type && action.type.startsWith('Partners/') && action.type.endsWith('/rejected');
};

const partnersAdapter = createEntityAdapter({
  selectId: (item) => item.id,
});

const partnerSlice = createSlice({
  name: 'partner',
  initialState: {
    action: null,
    isFetching: false,
    currentPartner: null,
    status: 'idle',
    metadata: {},
    entities: [],
    ids: [],
    item: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(doGetPartners.pending, (state) => {
      state.action = 'getall';
      state.status = 'loading';
    });
    builder.addCase(doGetPartners.fulfilled, (state, action) => {
      const { partners, pagination } = action.payload;
      state.status = 'succeeded';
      state.metadata = pagination;
      partnersAdapter.setAll(state, partners);
    });
    builder.addCase(doGetPartners.rejected, (state) => {
      state.status = 'failed';
      partnersAdapter.setAll(state, []);
    });
    builder.addCase(doGetPartner.pending, (state) => {
      state.action = 'getOne';
      state.status = 'loading';
    });
    builder.addCase(doGetPartner.fulfilled, (state, action) => {
      state.status = 'succeeded';
      if (action.payload) {
        state.currentPartner = action.payload;
      }
    });
    builder.addCase(doGetPartner.rejected, (state) => {
      state.status = 'failed';
    });
    builder.addCase(doCreatePartner.pending, (state) => {
      state.action = 'create';
      state.status = 'loading';
    });
    builder.addCase(doCreatePartner.fulfilled, (state) => {
      state.status = 'succeeded';
    });
    builder.addCase(doCreatePartner.rejected, (state) => {
      state.status = 'failed';
    });
    builder.addCase(doUpdatePartner.pending, (state) => {
      state.action = 'update';
      state.status = 'loading';
    });
    builder.addCase(doUpdatePartner.fulfilled, (state) => {
      state.status = 'succeeded';
    });
    builder.addCase(doUpdatePartner.rejected, (state) => {
      state.status = 'failed';
    });
    builder.addCase(doRemovePartner.pending, (state) => {
      state.action = 'remove';
      state.status = 'loading';
    });
    builder.addCase(doRemovePartner.fulfilled, (state) => {
      state.status = 'succeeded';
    });
    builder.addCase(doRemovePartner.rejected, (state) => {
      state.status = 'failed';
    });
    builder.addMatcher(isActionWithPending, (state) => {
      state.isFetching = true;
      state.message = null;
    });
    builder.addMatcher(isActionWithFulfilled, (state) => {
      state.isFetching = false;
    });
    builder.addMatcher(isActionWithFailed, (state) => {
      state.isFetching = false;
      state.message = null;
    });
  },
});

export const {
  selectAll: selectAllPartners,
  selectById: selectPartnerById,
  selectIds: selectPartnerIds,
} = partnersAdapter.getSelectors((state) => state.partner);
const { reducer: PartnerReducer } = partnerSlice;
export default PartnerReducer;
